import { Config } from '../config';
import { JiraTicketCreation } from '../interfaces';
import { HttpService } from './http.service';

const path = `${Config.API}/api/v1/devices`;

export abstract class JiraService {
  /**
   * Creates a Jira ticket for a device (Field Services)
   */
  public static createTicket = (deviceId: string, payload: JiraTicketCreation): Promise<void> => {
    return HttpService.fetchAuthorized(`${path}/${deviceId}/jira`, {
      method: 'POST',
      body: JSON.stringify(payload),
    }).then((res) => res);
  };
}
